module.exports = __webpack_public_path__ + "img/feature_buy_id.0ea47645.png";